import Navbar from "./navbar/NavbarWithSearch";
import FavoriteList from "./FavoriteList";
import { useState } from "react";

export default function FavorietenPage() {
  const [query, setQuery] = useState("");
  const [search, setSearch] = useState("");
  const [homeButtonPressed, setHomeButtonPressed] = useState(false);
  return (
    <>
      <Navbar
        query={query}
        setQuery={setQuery}
        setSearch={setSearch}
        setHomeButtonPressed={setHomeButtonPressed}
      />
      <FavoriteList
        search={search}
        homeButtonPressed={homeButtonPressed}
        setHomeButtonPressed={setHomeButtonPressed}
      />
    </>
  );
}
